class CareersDirectory {
  constructor(section) {
    this.section = section;
    this.search = section.querySelector('[data-careers-search]');
    this.department = section.querySelector('[data-careers-department]');
    this.type = section.querySelector('[data-careers-type]');
    this.clearButtons = section.querySelectorAll('[data-careers-clear], [data-careers-empty-clear]');
    this.jobs = Array.from(section.querySelectorAll('[data-careers-job]'));
    this.empty = section.querySelector('[data-careers-empty]');
    this.count = section.querySelector('[data-careers-count]');
    this.countLabel = section.querySelector('[data-careers-count-label]');

    if (!this.search || !this.jobs.length) return;

    this.search.addEventListener('input', () => this.filter());
    this.department?.addEventListener('change', () => this.filter());
    this.type?.addEventListener('change', () => this.filter());
    this.clearButtons.forEach((button) => button.addEventListener('click', () => this.clear()));
    section.dataset.careersInitialized = 'true';
  }

  filter() {
    const query = this.search.value.trim().toLowerCase();
    const department = this.department?.value || '';
    const type = this.type?.value || '';
    let visible = 0;

    this.jobs.forEach((job) => {
      const matchesQuery = !query || job.dataset.search.includes(query);
      const matchesDepartment = !department || job.dataset.department === department;
      const matchesType = !type || job.dataset.type === type;
      const show = matchesQuery && matchesDepartment && matchesType;

      job.hidden = !show;
      if (!show) job.open = false;
      if (show) visible += 1;
    });

    this.empty.hidden = visible !== 0;
    this.count.textContent = visible;
    this.countLabel.textContent = visible === 1 ? 'opportunity in Chino, California' : 'opportunities in Chino, California';
  }

  clear() {
    this.search.value = '';
    if (this.department) this.department.value = '';
    if (this.type) this.type.value = '';
    this.filter();
    this.search.focus();
  }
}

const initializeCareers = (scope = document) => {
  scope.querySelectorAll('[data-careers-section]:not([data-careers-initialized])').forEach((section) => {
    new CareersDirectory(section);
  });
};

document.addEventListener('DOMContentLoaded', () => initializeCareers());
document.addEventListener('shopify:section:load', (event) => initializeCareers(event.target));
